import { render, staticRenderFns } from "./EmployeeClient.vue?vue&type=template&id=ec7b2898&scoped=true&"
import script from "./EmployeeClient.vue?vue&type=script&lang=js&"
export * from "./EmployeeClient.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeClient.vue?vue&type=style&index=0&id=ec7b2898&scoped=true&lang=less&"
import style1 from "./EmployeeClient.vue?vue&type=style&index=1&id=ec7b2898&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7b2898",
  null
  
)

export default component.exports